/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import 'react-mde/lib/styles/css/react-mde-all.css';

import { memo, useMemo } from 'react';
import ReactMde from 'react-mde';

import { MarkdownEditorProps } from './types';

export const MarkdownEditor = memo<MarkdownEditorProps>(({ value, onChange }) => {
  const memoizedValue = useMemo(() => value, [value]);
  return <ReactMde value={memoizedValue} onChange={onChange} disablePreview />;
});
